import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@design-system-coopeuch/web';
import { WrapperPreguntaEncuestaInput } from './styles';

const PreguntaEncuestaInput = ({
  campoObligatorio,
  respuestaTexto,
  setRespuestaTexto,
  maxLength,
  labelPrimario,
  labelSecundario,
  label
}) => {
  const [currentLength, setCurrentLength] = useState(0);

  const handleChange = (e) => {
    setRespuestaTexto(e);
    setCurrentLength(e.length);
  };

  return (
    <WrapperPreguntaEncuestaInput>
      <Input
        type="text"
        assistText={campoObligatorio ? 'Campo obligatorio' : 'Campo opcional'}
        label={label === 1 || label === 0 ? labelPrimario : labelSecundario}
        value={respuestaTexto}
        onChange={(e) => handleChange(e)}
        maxLength={maxLength}
        allowSpaces
        variant="text"
      />
      <span className="contadorCaracteres">{`${currentLength}/${maxLength}`}</span>
    </WrapperPreguntaEncuestaInput>
  );
};

PreguntaEncuestaInput.propTypes = {
  campoObligatorio: PropTypes.bool.isRequired,
  respuestaTexto: PropTypes.string.isRequired,
  setRespuestaTexto: PropTypes.func.isRequired,
  maxLength: PropTypes.number.isRequired,
  labelPrimario: PropTypes.string.isRequired,
  labelSecundario: PropTypes.string.isRequired,
  label: PropTypes.number.isRequired
};

export default PreguntaEncuestaInput;
